import * as mig001 from './001-init.js'
import * as mig002 from './002-account-deactivation.js'
import * as mig003 from './003-privileged-app-passwords.js'
import * as mig004 from './004-oauth.js'
import * as mig005 from './005-oauth-account-management.js'
import * as mig006 from './006-oauth-permission-sets.js'
import * as mig007 from './007-lexicon-failures-index.js'

export default {
  '001': mig001,
  '002': mig002,
  '003': mig003,
  '004': mig004,
  '005': mig005,
  '006': mig006,
  '007': mig007,
}
